/*
 * @Author: Chao Yang
 * @Date: 2022-08-30 11:12:50
 * @LastEditor: Chao Yang
 * @LastEditTime: 2022-12-16 13:20:45
 */
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators";
import { IDocumentPage } from "../../model/document-viewer/iDocumentPage.model";
import { BaseProxy } from "../base.proxy";

@Injectable()
export class DocumentViewerProxy extends BaseProxy {
  postPages(id: number) {
    return this._http.post<IDocumentPage[]>(`/ip/api/document/viewer/word/pages`, {}, {
      params: {
        id: id + '',
        clientTimeOffset: (new Date().getTimezoneOffset()) + ''
      }
    }).pipe(map(data => {
      data.forEach(item => {
        item.img = '/ip/api/document/viewer/word/image/' + item.pageName
      });
      return data;
    }));
  }

  fetchExcelPrintImages(id: number) {
    return this._http.post<IDocumentPage[]>(`/ip/api/document/viewer/excel/print`, {}, {
      params: {
        id: id + '',
        clientTimeOffset: (new Date().getTimezoneOffset()) + ''
      }
    }).pipe(map(data => {
      data.forEach(item => {
        item.img = '/ip/api/document/viewer/excel/getPrintImage/' + item.pageName
      });
      return data;
    }));
  }

  postPagesForTrackRecord(link: string) {
    return this._http.post<IDocumentPage[]>(`/ip/api/document/viewer/word/PagesForTrackRecord`, {}, {
      params: {
        url: link
      }
    }).pipe(map(data => {
      data.forEach(item => {
        item.img = '/ip/api/document/viewer/word/imageForTrackRecord/' + item.pageName
      });
      return data;
    }));
  }
}
